import React, { useState } from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import Header from '../Component/Header'
import PageHead from '../Component/pageHead'
import Footer from '../Component/footer'
import { useFormik } from 'formik'
import { PostAction } from '../Component/PostAction'
import { Link, useHistory, useLocation } from 'react-router-dom'
import {
  applyLoginResponse,
  changePasswordPath,
  forgotPasswordPath,
  needsPasswordChange,
  safeReturnPath,
  signUpPath,
} from '../utils/sessionAuth'

const initialformData = {
  username: '',
  password: '',
}

function Login() {
  const [formData] = useState(initialformData)
  const postUrl = 'user/loginCheck'
  const history = useHistory()
  const location = useLocation()
  const returnUrl = safeReturnPath(new URLSearchParams(location.search).get('returnUrl'))
  const fromDonation = returnUrl === '/Donation'

  const { values, handleChange, handleSubmit } = useFormik({
    initialValues: formData,
    onSubmit: (values) => {
      const callPOSTAPI = async () => {
        const res = await PostAction(
          'post',
          {
            username: String(values.username || '').trim(),
            password: values.password,
          },
          postUrl
        )
        if (applyLoginResponse(res)) {
          if (needsPasswordChange()) {
            history.push(changePasswordPath(returnUrl || '/'))
          } else {
            history.push(returnUrl || '/')
          }
        } else {
          alert(res?.message || res?.data?.message || 'Login Failed!')
        }
      }
      callPOSTAPI()
    },
  })

  return (
    <>
      <Header />
      <PageHead title="Login" />
      <div className="container" style={{ fontSize: 20, minHeight: '615px' }}>
        <div className="card mx-auto" style={{ maxWidth: 520 }}>
          <div className="card-body">
            {fromDonation ? (
              <p className="mb-3" style={{ fontSize: 16 }}>
                Please log in to continue your donation. After login you will return to the
                donation page with your details saved.
              </p>
            ) : null}
            <Form onSubmit={handleSubmit}>
              <Row className="mb-3 g-2 align-items-center">
                <Col xs={12} md="auto" className="text-md-end pe-md-2" style={{ minWidth: 140 }}>
                  <label className="form-label mb-1 mb-md-0" htmlFor="login-username">
                    Email or mobile
                  </label>
                </Col>
                <Col xs={12} md className="ps-md-0">
                  <input
                    id="login-username"
                    className="form-control"
                    type="text"
                    name="username"
                    value={values.username}
                    onChange={handleChange}
                    autoComplete="username"
                    placeholder="email@example.com or 10-digit mobile"
                  />
                </Col>
              </Row>
              <Row className="mb-3 g-2 align-items-center">
                <Col xs={12} md="auto" className="text-md-end pe-md-2" style={{ minWidth: 140 }}>
                  <label className="form-label mb-1 mb-md-0" htmlFor="login-password">
                    Password
                  </label>
                </Col>
                <Col xs={12} md className="ps-md-0">
                  <input
                    id="login-password"
                    className="form-control"
                    type="password"
                    name="password"
                    value={values.password}
                    onChange={handleChange}
                    autoComplete="current-password"
                  />
                  <div className="text-md-end mt-1">
                    <Link to={forgotPasswordPath(returnUrl)} style={{ fontSize: 15 }}>
                      Forgot password?
                    </Link>
                  </div>
                </Col>
              </Row>
              <div className="text-center">
                <button className="btn btn-primary" type="submit">
                  Login
                </button>
                <p className="mt-3 mb-0" style={{ fontSize: 16 }}>
                  New here? <Link to={signUpPath(returnUrl)}>Sign Up</Link>
                </p>
              </div>
            </Form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default Login
